import { CommonModule, isPlatformBrowser } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnInit, ViewChild } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { MatCardModule } from "@angular/material/card";
import { MatDialogModule } from "@angular/material/dialog";
import { MatIconModule } from "@angular/material/icon";
import { MatPaginator, MatPaginatorModule } from "@angular/material/paginator";
import { MatSort, MatSortModule } from "@angular/material/sort";
import { MatTableDataSource, MatTableModule } from "@angular/material/table";
import { MatTooltipModule } from "@angular/material/tooltip";
import { LoaderComponent } from "../../../general/components/loader/loader.component";
import { GlassPillDirective } from "../../../general/directives/glass-pill.directive";
import { ReferralUrlService, ReferralUrlWithCount } from "../../../../features/sales/services/referral-url.service";
import { PropertyService } from "../../../../features/property/services/property.service";
import { Property, PropertySummaryDto, PropertyViewModel } from "../../../../features/property/models/property.model";
import { forkJoin, map, switchMap, tap } from "rxjs";
import { PropertyLikeService } from "../../../../features/property/services/property-like.service";
import { Router } from "@angular/router";

@Component({
  selector: 'app-property-list-admin',
  standalone: true,
  imports: [
    CommonModule,
    MatTableModule,
    MatIconModule,
    MatButtonModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatDialogModule,
    MatSortModule,
    MatCardModule,
    LoaderComponent,
    GlassPillDirective
  ],
  templateUrl: './property-list.html',
  styleUrl: './property-list.scss',
})
export class PropertyList implements OnInit {
    propertyService = inject(PropertyService);
    likeService = inject(PropertyLikeService);
    router = inject(Router);
    cdr = inject(ChangeDetectorRef);
    dataSource = new MatTableDataSource<PropertySummaryDto>();
    isLoading = false;
    displayedColumns: string[] = ['isPublished', 'image', 'displayName', 'location', 'owner', 'saveCount', 'created', 'expires'];
  
    @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
        this.dataSource.paginator = mp;
    }

    @ViewChild(MatSort) set matSort(ms: MatSort) {
        this.dataSource.sort = ms;
    }

    ngOnInit() {
        this.loadProperties();
    }

    loadProperties() {
        this.propertyService.getAll().pipe(tap(result => {
            this.dataSource.data = result;
            console.log('propertyRequests', result);
            this.cdr.detectChanges();
        })
        ).subscribe();
        
        // .subscribe(result => {
        //     this.dataSource.data = result;
        //     this.cdr.detectChanges();
        // });
    }

    viewProperty(propertyId: string) {
        this.router.navigate(['/property', propertyId]);
    }
}